import { API } from './../api/api'
import { fetch, post } from './../api/httpClient'
import localStorageService from './../api/localStorageService'
import { MESSAGE_SEVERITIES } from './../helpers/constants'
import ActionTypes from './actionTypes'
import { cappingAction, licenseAction, messageAction } from './app.action'

export const metadataAction = (data) => (dispatch) => {
  dispatch({
    type: ActionTypes.METADATA,
    data,
  })
}

export const fetchLicenseDetails = (tenant, successCallback, errorCallback) => async (dispatch) => {
  const { accountId } = localStorageService.getAccessToken()
  try {
    const apiPath = `${API.LICENSEDETAILS}/${accountId}`
    const response = await fetch(apiPath)
    dispatch(licenseAction(response?.data?.app_access))
    dispatch(cappingAction(response?.data?.capping_data))
    if (typeof successCallback === 'function') {
      successCallback(response.data)
    }
  } catch (err) {
    if (typeof errorCallback === 'function') {
      errorCallback(err)
    }
  }
}

export const fetchTenantMetadata = (successCallback, failureCallback) => async (dispatch) => {
  const { accountId } = localStorageService.getAccessToken()

  try {
    const url = `${API.CORE.METADATA}?metaType=tenant&metaTypeId=${accountId}`
    let { data } = await fetch(url)
    data = data.reduce((value, currentItem) => {
      value[currentItem.md_meta_key] = currentItem.md_meta_value
      return value
    }, {})
    dispatch(metadataAction(data))
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const addUpdateTenantMetadata =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    const { accountId } = localStorageService.getAccessToken()
    const updatedPayload = Object.keys(payload).map((meta) => ({
      md_meta_type: 'tenant',
      md_meta_type_id: accountId,
      md_meta_key: meta,
      md_meta_value: payload[meta],
    }))

    try {
      await post(API.CORE.METADATA, updatedPayload)
      dispatch(fetchTenantMetadata())
      dispatch(
        messageAction({
          subTitle: 'message:appSettingUpdated',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const fetchTmsTenantMetadata = (successCallback, failureCallback) => async () => {
  try {
    const url = `${API.CORE.TENANTMETADATA}`
    let { data } = await fetch(url)
    if (typeof successCallback === 'function') {
      successCallback(data)
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}

export const addUpdateTMSTenantMetadata =
  (payload, successCallback, failureCallback) => async (dispatch) => {
    const updatedPayload = {
      metadata: {
        default_inapp_topic: payload.default_inapp_topic1,
        default_email_topic: payload.default_email_topic1,
        default_sms_topic: payload.default_sms_topic1,
      },
    }

    try {
      await post(API.CORE.TENANTMETADATA, updatedPayload)
      dispatch(
        messageAction({
          subTitle: 'message:appSettingUpdated',
          severity: MESSAGE_SEVERITIES.SUCCESS,
        })
      )
      if (typeof successCallback === 'function') {
        successCallback()
      }
    } catch (error) {
      if (typeof failureCallback === 'function') {
        failureCallback(error)
      }
    }
  }

export const addUpdateMetadata = (payload, successCallback, failureCallback) => async () => {
  try {
    await post(API.CORE.METADATA, payload)

    if (typeof successCallback === 'function') {
      successCallback()
    }
  } catch (error) {
    if (typeof failureCallback === 'function') {
      failureCallback(error)
    }
  }
}
